// src/loaders/dashboards/onChainPageDashboardLoader.ts

import type { LoaderFunctionArgs } from "react-router-dom";
import { QueryClient } from "@tanstack/react-query";
import { sectorQueryOptions } from "@/services/queries/dashboards/sectorQueries";
import type { SectorDashboardResponse } from "@/types/dashboards/dashboardResponses";

export async function onChainPageDashboardLoader({
  context,
}: LoaderFunctionArgs): Promise<SectorDashboardResponse | null> {
  const queryClient = context?.queryClient as QueryClient;

  if (!queryClient) {
    throw new Error("QueryClient not found in loader context");
  }

  try {
    // Start fetching data in the background without blocking navigation
    // This allows the page to render immediately while data loads
    queryClient.prefetchQuery(sectorQueryOptions());
    
    // Return null to allow immediate navigation
    // The component will handle loading state via React Query hooks
    return null;
  } catch (error) {
    console.error("Error in onChainPageDashboardLoader:", error);

    // React Router will catch this and pass it to your error boundary
    throw new Response(
      JSON.stringify({
        message:
          error instanceof Error
            ? error.message
            : "Failed to load dashboard data",
        error: "LOADER_ERROR",
      }),
      {
        status: 500,
        statusText: "Internal Server Error",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }
}
